import { QRATableLineViewMode } from 'features/RiskManagement/Components/Tables'

interface ILineViewToggle {
  viewMode: QRATableLineViewMode
  setViewMode: (type: QRATableLineViewMode) => void
}

const LineViewToggle = ({ viewMode, setViewMode }: ILineViewToggle) => {
  const activeClasses = [
    'flex-none p-3',
    'bg-lighthouseBlue',
    'bg-opacity-30',
    'font-medium'
  ].join(' ')

  const inactiveClasses = [
    'flex-none p-3',
    'bg-lighthouseBlue',
    'bg-opacity-10 text-gray-500',
    'font-medium'
  ].join(' ')

  return (
    <div className='flex border-r px-4'>
      <button
        className={[
          'h-10 rounded-l leading-none',
          viewMode === QRATableLineViewMode.Output
            ? activeClasses
            : inactiveClasses
        ].join(' ')}
        onClick={() => setViewMode(QRATableLineViewMode.Output)}
      >
        Risk Output
      </button>
      <button
        className={[
          'h-10 rounded-r leading-none',
          viewMode === QRATableLineViewMode.Input
            ? activeClasses
            : inactiveClasses
        ].join(' ')}
        onClick={() => setViewMode(QRATableLineViewMode.Input)}
      >
        Risk Input
      </button>
    </div>
  )
}

export default LineViewToggle
